const atomsObj = {
  "bed": {
    "name": "bed",
    "list": {
      "t08": {
        "alias": "t08",
        "name": "spadari",
        "active": true
      },
      "t09": {
        "alias": "t09",
        "name": "manzoni",
        "active": true
      },
      "t10": {
        "alias": "t10",
        "name": "cordusio",
        "active": true
      },
      "t11": {
        "alias": "t11",
        "name": "spiga",
        "active": true
      },
      "t12": {
        "alias": "t12",
        "name": "montenapolene",
        "active": true
      },
      "t13": {
        "alias": "t13",
        "name": "durini",
        "active": true
      }
    }
    
  },
  "wooden": {
    "name": "wooden",
    "list": {
      "darkOak": {
        "alias": "darkOak",
        "name": "dark oak",
        "active": true
      }
    }
    
  },
  "ecoNabuk": {
    "name": "eco nabuk",
    "list": {
      "darkBrown08": {
        "alias": "darkBrown08",
        "name": "dark brown 08",
        "active": true
      },
      "darkGrey13": {
        "alias": "darkGrey13",
        "name": "dark grey 13",
        "active": true
      },
      "ivory01": {
        "alias": "ivory01",
        "name": "ivory 01",
        "active": true
      },
      "lightGrey11": {
        "alias": "lightGrey11",
        "name": "light grey 11",
        "active": true
      },
      "sand02": {
        "alias": "sand02",
        "name": "sand 11",
        "active": true
      }
    }
  },
  "fabric": {
    "name": "fabric",
    "list": {
      "darkGrey15_2": {
        "alias": "darkGrey15_2",
        "name": "dark grey 15-2",
        "active": true
      },
      "lightGrey12_1": {
        "alias": "lightGrey12_1",
        "name": "light grey 12-1",
        "active": true
      },
      "taupe2_1": {
        "alias": "taupe2_1",
        "name": "taupe 2-1",
        "active": true
      },
      "white2_1": {
        "alias": "white2_1",
        "name": "white 2-1",
        "active": true
      }
    }
  },
  "vintageEcoLeather": {
    "name": "vintage eco leather",
    "list": {
      "black107": {
        "alias": "black107",
        "name": "black 107",
        "active": true
      },
      "lightGrey1009": {
        "alias": "lightGrey1009",
        "name": "dark grey 1009",
        "active": true
      },
      "darkBrown106": {
        "alias": "darkBrown106",
        "name": "dark brow 106",
        "active": true
      },
      "white1008": {
        "alias": "white1008",
        "name": "white 001",
        "active": true
      }
    }
  },
  "embroideryBrown": {
    "name": "embroidery",
    "list": {
      "bicoccaBlackWhite": {
        "alias": "bicoccaBlackWhite",
        "name": "black white",
        "subType": "bicocca",
        "active": true
      },
      "bicoccaBordeauxWhite": {
        "alias": "bicoccaBordeauxWhite",
        "name": "black bordeaux white",
        "subType": "bicocca",
        "active": true
      },
      "bicoccaDkChocolateWhite": {
        "alias": "bicoccaDkChocolateWhite",
        "name": "dark Chocolate white",
        "subType": "bicocca",
        "active": true
      },
      "bicoccaDkGoldWhite": {
        "alias": "bicoccaDkGoldWhite",
        "name": "dark gold white",
        "subType": "bicocca",
        "active": true
      },
      "bicoccaDkGreyWhite": {
        "alias": "bicoccaDkGreyWhite",
        "name": "dark grey white",
        "subType": "bicocca",
        "active": true
      },
      "bicoccaGrGreen7972_7526_7411_7414": {
        "alias": "bicoccaGrGreen7972_7526_7411_7414",
        "name": "grass green 7972",
        "subType": "bicocca",
        "active": true
      },
      "bicoccaIndBlueWhite": {
        "alias": "bicoccaIndBlueWhite",
        "name": "indigo blue white",
        "subType": "bicocca",
        "active": true
      },
      "bicoccaLtGrey9901_9946_9509_9355": {
        "alias": "bicoccaLtGrey9901_9946_9509_9355",
        "name": "light grey 9901",
        "subType": "bicocca",
        "active": true
      },
      "bicoccaPrPink3955_3377_3364_3135": {
        "alias": "bicoccaPrPink3955_3377_3364_3135",
        "name": "prussian pink 3955",
        "subType": "bicocca",
        "active": true
      },
      "bicoccaWhiteBlack": {
        "alias": "bicoccaWhiteBlack",
        "name": "white black",
        "subType": "bicocca",
        "active": true
      },
      "bicoccaWhiteBordeaux": {
        "alias": "bicoccaWhiteBordeaux",
        "name": "white bordeaux",
        "subType": "bicocca",
        "active": true
      },
      "bicoccaDarkGrey": {
        "alias": "bicoccaDarkGrey",
        "name": "dark grey",
        "subType": "bicocca",
        "active": true
      },
      "bicoccaWhiteDkChocolate": {
        "alias": "bicoccaWhiteDkChocolate",
        "name": "white dark chocolate",
        "subType": "bicocca",
        "active": true
      },
      "bicoccaWhiteDkGold": {
        "alias": "bicoccaWhiteDkGold",
        "name": "white dark gold",
        "subType": "bicocca",
        "active": true
      },
      "bicoccaWhiteDkGrey": {
        "alias": "bicoccaWhiteDkGrey",
        "name": "white dark grey",
        "subType": "bicocca",
        "active": true
      },
      "bicoccaWhiteGrGreen": {
        "alias": "bicoccaWhiteGrGreen",
        "name": "white grass green",
        "subType": "bicocca",
        "active": true
      },
      "bicoccaWhiteIndBlue": {
        "alias": "bicoccaWhiteIndBlue",
        "name": "white indigo blue",
        "subType": "bicocca",
        "active": true
      },
      "bicoccaWhiteIvory": {
        "alias": "bicoccaWhiteIvory",
        "name": "white ivory",
        "subType": "bicocca",
        "active": true
      },
      "bicoccaLtGold": {
        "alias": "bicoccaLtGold",
        "name": "light gold",
        "subType": "bicocca",
        "active": true
      },
      "bicoccaLtGrey": {
        "alias": "bicoccaLtGrey",
        "name": "light grey",
        "subType": "bicocca",
        "active": true
      },
      "bicoccaWhiteNavy": {
        "alias": "bicoccaWhiteNavy",
        "name": "white navy",
        "subType": "bicocca",
        "active": true
      },
      "bicoccaWhiteOrange": {
        "alias": "bicoccaWhiteOrange",
        "name": "white orange",
        "subType": "bicocca",
        "active": true
      },
      "bicoccaWhitePeri": {
        "alias": "bicoccaWhitePeri",
        "name": "white peri",
        "subType": "bicocca",
        "active": true
      },
      "bicoccaWhitePink": {
        "alias": "bicoccaWhitePink",
        "name": "white pink",
        "subType": "bicocca",
        "active": true
      },
      "bicoccaSand": {
        "alias": "bicoccaSand",
        "name": "sand",
        "subType": "bicocca",
        "active": true
      },
      "bicoccaWhiteTurquoise": {
        "alias": "bicoccaWhiteTurquoise",
        "name": "white turquoise",
        "subType": "bicocca",
        "active": true
      },
      "bicoccaWhiteViolet": {
        "alias": "bicoccaWhiteViolet",
        "name": "white violet",
        "subType": "bicocca",
        "active": true
      }
    }
    
  },
  "embroideryPurple": {
    "name": "embroidery",
    "list": {
      "accademiaBordeauxWhite": {
        "alias": "accademiaBordeauxWhite",
        "name": "bordeaux white",
        "subType": "accademia",
        "active": true
      },
      "accademiaDkChocolateWhite": {
        "alias": "accademiaDkChocolateWhite",
        "name": "dark chocolate white",
        "subType": "accademia",
        "active": true
      },
      "accademiaDkGreyWhite": {
        "alias": "accademiaDkGreyWhite",
        "name": "dark grey white",
        "subType": "accademia",
        "active": true
      },
      "accademiaOrangeWhite": {
        "alias": "accademiaOrangeWhite",
        "name": "orange white",
        "subType": "accademia",
        "active": true
      },
      "medaDkGreyLtGrey": {
        "alias": "medaDkGreyLtGrey",
        "name": "dark grey light grey",
        "subType": "meda",
        "active": true
      },
      "medaIndBluePeri": {
        "alias": "medaIndBluePeri",
        "name": "indigo blue peri",
        "subType": "meda",
        "active": true
      },
      "medaOrangePrPink": {
        "alias": "medaOrangePrPink",
        "name": "orange prussian pink",
        "subType": "meda",
        "active": true
      },
      "medaSandWhite": {
        "alias": "medaSandWhite",
        "name": "sand white",
        "subType": "meda",
        "active": true
      },
      "necchiBordeauxWhiteTurquoise": {
        "alias": "necchiBordeauxWhiteTurquoise",
        "name": "bordeaux white turquoise",
        "subType": "necchi",
        "active": true
      },
      "necchiIndBlueWhiteOrange": {
        "alias": "necchiIndBlueWhiteOrange",
        "name": "indigo blue white orange",
        "subType": "necchi",
        "active": true
      },
      "necchiOrangeWhiteBlue": {
        "alias": "necchiOrangeWhiteBlue",
        "name": "orange white blue",
        "subType": "necchi",
        "active": true
      },
      "necchiTurquoiseWhiteBordeaux": {
        "alias": "necchiTurquoiseWhiteBordeaux",
        "name": "turquoise white bordeaux",
        "subType": "necchi",
        "active": true
      },
      "palazzoRealeBordeauxPrPinkWhite": {
        "alias": "palazzoRealeBordeauxPrPinkWhite",
        "name": "bordeaux prussian pink white",
        "subType": "palazzoReale",
        "active": true
      },
      "palazzoRealeDkChocolateLtGreyWhite": {
        "alias": "palazzoRealeDkChocolateLtGreyWhite",
        "name": "dark chocolate light grey white",
        "subType": "palazzoReale",
        "active": true
      },
      "palazzoRealeDkGreyPeriWhite": {
        "alias": "palazzoRealeDkGreyPeriWhite",
        "name": "dark grey peri white",
        "subType": "palazzoReale",
        "active": true
      },
      "palazzoRealeVioletGrGreenWhite": {
        "alias": "palazzoRealeVioletGrGreenWhite",
        "name": "violet grass green white",
        "subType": "palazzoReale",
        "active": true
      },
      "sempioneDkGreyBordeauxGold": {
        "alias": "sempioneDkGreyBordeauxGold",
        "name": "dark grey bordeaux gold",
        "subType": "sempione",
        "active": true
      },
      "sempioneGrGreenIndBluePeri": {
        "alias": "sempioneGrGreenIndBluePeri",
        "name": "grass green indigo blue peri",
        "subType": "sempione",
        "active": true
      },
      "sempioneIndBlueOrangeGrGreen": {
        "alias": "sempioneIndBlueOrangeGrGreen",
        "name": "indigo blue orange grass green",
        "subType": "sempione",
        "active": true
      },
      "sempioneSandBlackWhite": {
        "alias": "sempioneSandBlackWhite",
        "name": "sand black white",
        "subType": "sempione",
        "active": true
      },
      "velaBlackWhite": {
        "alias": "velaBlackWhite",
        "name": "black white",
        "subType": "vela",
        "active": true
      },
      "velaDkChocolateLtGrey": {
        "alias": "velaDkChocolateLtGrey",
        "name": "dark chocolate light grey",
        "subType": "vela",
        "active": true
      },
      "velaDkGoldWhite": {
        "alias": "velaDkGoldWhite",
        "name": "dark gold white",
        "subType": "vela",
        "active": true
      },
      "velaDkGreyWhite": {
        "alias": "velaDkGreyWhite",
        "name": "dark grey white",
        "subType": "vela",
        "active": true
      },
      "velascaBlackOrangeWhite": {
        "alias": "velascaBlackOrangeWhite",
        "name": "black orange white",
        "subType": "velasca",
        "active": true
      },
      "velascaLtGreyDkGreyWhite": {
        "alias": "velascaLtGreyDkGreyWhite",
        "name": "light grey dark grey white",
        "subType": "velasca",
        "active": true
      },
      "velascaOrangeDkChocolateWhite": {
        "alias": "velascaOrangeDkChocolateWhite",
        "name": "orange dark chocolate white",
        "subType": "velasca",
        "active": true
      },
      "velascaSandBordeauxWhite": {
        "alias": "velascaSandBordeauxWhite",
        "name": "sand bordeaux white",
        "subType": "velasca",
        "active": true
      }
    }
  },
  "embroideryRed": {
    "name": "embroidery",
    "list": {
      "accademiaWhite3955_3377_3364": {
        "alias": "accademiaWhite3955_3377_3364",
        "name": "white 3955 3377 3364",
        "subType": "accademia",
        "active": true
      },
      "accademiaWhite3884_386_2246": {
        "alias": "accademiaWhite3884_386_2246",
        "name": "white 3884 386 2246",
        "subType": "accademia",
        "active": true
      },
      "accademiaWhite8932_865_8376": {
        "alias": "accademiaWhite8932_865_8376",
        "name": "white 8932",
        "subType": "accademia",
        "active": true
      },
      "accademiaWhite9946_9509_9355": {
        "alias": "accademiaWhite9946_9509_9355",
        "name": "white 9946",
        "subType": "accademia",
        "active": true
      },
      "palazzoRealeWhiteBordeauxPwPink": {
        "alias": "palazzoRealeWhiteBordeauxPwPink",
        "name": "white bordeaux powder pink",
        "subType": "palazzoReale",
        "active": true
      },
      "palazzoRealeWhiteDkChocolateLtGrey": {
        "alias": "palazzoRealeWhiteDkChocolateLtGrey",
        "name": "white dark chocolate light grey",
        "subType": "palazzoReale",
        "active": true
      },
      "palazzoRealeWhiteDkGreyPeri": {
        "alias": "palazzoRealeWhiteDkGreyPeri",
        "name": "white dark grey peri",
        "subType": "palazzoReale",
        "active": true
      },
      "palazzoRealeWhiteVioletGrGreen": {
        "alias": "palazzoRealeWhiteVioletGrGreen",
        "name": "white violet grass green",
        "subType": "palazzoReale",
        "active": true
      },
      "velaDkGreyWhite_b": {
        "alias": "velaDkGreyWhite_b",
        "name": "dark grey white",
        "subType": "vela",
        "active": true
      },
      "velaLtGreyDkChocolate": {
        "alias": "velaLtGreyDkChocolate",
        "name": "grey dark chocolate",
        "subType": "vela",
        "active": true
      },
      "velaWhiteDkGold": {
        "alias": "velaWhiteDkGold",
        "name": "white dark gold",
        "subType": "vela",
        "active": true
      },
      "velaWhiteDkGrey": {
        "alias": "velaWhiteDkGrey",
        "name": "white dark grey",
        "subType": "vela",
        "active": true
      }
    }
  },
  "embroideryYellow": {
    "name": "embroidery",
    "list": {
      "cityLifeBordeauxPwPink": {
        "alias": "cityLifeBordeauxPwPink",
        "name": "bordeaux powder pink",
        "subType": "city life",
        "active": true
      },
      "cityLifeDkChocolateLTGrey": {
        "alias": "cityLifeDkChocolateLTGrey",
        "name": "dark chocolate light pink",
        "subType": "city life",
        "active": true
      },
      "cityLifeDKGreyLtGrey": {
        "alias": "cityLifeDkChocolateLTGrey",
        "name": "dark grey light grey",
        "subType": "city life",
        "active": true
      },
      "cityLifeIndBlueGrGreen": {
        "alias": "cityLifeIndBlueGrGreen",
        "name": "indaco blue grass green",
        "subType": "city life",
        "active": true
      },
      "galleriaDkChocolateOrange": {
        "alias": "galleriaDkChocolateOrange",
        "name": "dark chocolate orange",
        "subType": "galleria",
        "active": true
      },
      "galleriaDkGreyPeri": {
        "alias": "galleriaDkGreyPeri",
        "name": "dark grey peri",
        "subType": "galleria",
        "active": true
      },
      "galleriaSandWhite": {
        "alias": "galleriaSandWhite",
        "name": "dark sand white",
        "subType": "galleria",
        "active": true
      },
      "galleriaTurquoiseDkGold": {
        "alias": "galleriaTurquoiseDkGold",
        "name": "turquoise gold",
        "subType": "galleria",
        "active": true
      },
      "medaDkGreyLtGreye": {
        "alias": "medaDkGreyLtGreye",
        "name": "dark grey light grey",
        "subType": "meda",
        "active": true
      },
      "medaIndBluePeri_c": {
        "alias": "medaIndBluePeri_c",
        "name": "indaco blue peri",
        "subType": "meda",
        "active": true
      },
      "medaOrangePwPink": {
        "alias": "medaOrangePwPink",
        "name": "orange powder pink",
        "subType": "meda",
        "active": true
      },
      "medaWhiteSand": {
        "alias": "medaWhiteSand",
        "name": "sand",
        "subType": "meda",
        "active": true
      }
    }
  },
  "environment": {
    "name": "environment",
    "list": {
      "environment429C": {
        "alias": "environment429C",
        "name": "429C",
        "active": true
      },
      "environment5025C": {
        "alias": "environment5025C",
        "name": "5025C",
        "active": true
      },
      "environment644C": {
        "alias": "environment644C",
        "name": "644C",
        "active": true
      },
      "environmentCoolGrey1C": {
        "alias": "environmentCoolGrey1C",
        "name": "cool grey 1c",
        "active": true
      },
      "environmentWarmGrey3C": {
        "alias": "environmentWarmGrey3C",
        "name": "warm grey 3c",
        "active": true
      },
      "environmentWhite": {
        "alias": "environmentWhite",
        "name": "white",
        "active": true
      }
    } 
  },
  "fashionGreen": {
    "name": "fashion",
    "list": {
      "darsenaIndBlueDkGrey": {
        "alias": "darsenaIndBlueDkGrey",
        "name": "indigo blue dark grey",
        "subType": "darsena",
        "active": true
      },
      "darsenaOrangeDkGrey": {
        "alias": "darsenaOrangeDkGrey",
        "name": "white",
        "subType": "darsena",
        "active": true
      },
      "necchiOrangeIndBlue": {
        "alias": "necchiOrangeIndBlue",
        "name": "orange indigo blue",
        "subType": "necchi",
        "active": true
      },
      "necchiTurquoiseBordeaux": {
        "alias": "necchiTurquoiseBordeaux",
        "name": "turquoise bordeaux",
        "subType": "necchi",
        "active": true
      },
      "ortoBotanicoDkGreyLtGold": {
        "alias": "ortoBotanicoDkGreyLtGold",
        "name": "dark grey light gold",
        "subType": "ortoBotanico",
        "active": true
      },
      "ortoBotanicoGrGreenIndBlue": {
        "alias": "ortoBotanicoGrGreenIndBlue",
        "name": "grass green indigo blue",
        "subType": "ortoBotanico",
        "active": true
      },
      "parcoAcquaPeriDkGold": {
        "alias": "parcoAcquaPeriDkGold",
        "name": "peri dark gold",
        "subType": "parcoAcqua",
        "active": true
      },
      "parcoAcquaPwPinkDkGold": {
        "alias": "parcoAcquaPwPinkDkGold",
        "name": "powder pink dark gold",
        "subType": "parcoAcqua",
        "active": true
      },
      "rosetoOrangeDkGrey": {
        "alias": "rosetoOrangeDkGrey",
        "name": "orange dark grey",
        "subType": "roseto",
        "active": true
      },
      "rosetoSandDkGrey": {
        "alias": "rosetoSandDkGrey",
        "name": "sand dark grey",
        "subType": "roseto",
        "active": true
      },
      "rosetoSanBabila": {
        "alias": "rosetoSanBabila",
        "name": "roseto San Babila",
        "subType": "roseto",
        "active": true
      },
      "rosetoSempione": {
        "alias": "rosetoSempione",
        "name": "roseto Sempione",
        "subType": "roseto",
        "active": true
      }
    }
  },
  "jacquardOrange": {
    "name": "jacquard",
    "list": {
      "cityLifeBordeauxPrPinkBordeaux": {
        "alias": "cityLifeBordeauxPrPinkBordeaux",
        "name": "bordeaux prussian pink bordeaux",
        "subType": "cityLife",
        "active": true
      },
      "cityLifeDkGreyLtGreyDkGrey": {
        "alias": "cityLifeDkGreyLtGreyDkGrey",
        "name": "dark grey light grey dark grey",
        "subType": "cityLife",
        "active": true
      },
      "cityLifeIndBlueGrGreenIndBlue": {
        "alias": "cityLifeIndBlueGrGreenIndBlue",
        "name": "indigo blue grass green indigo blue",
        "subType": "cityLife",
        "active": true
      },
      "galleriaDkChocolateOrangeDkChocolate": {
        "alias": "galleriaDkChocolateOrangeDkChocolate",
        "name": "dark chocolate orange dark chocolate",
        "subType": "galleria",
        "active": true
      },
      "galleriaDkGreyPeriDkGrey": {
        "alias": "galleriaDkGreyPeriDkGrey",
        "name": "dark grey peri dark grey",
        "subType": "galleria",
        "active": true
      },
      "galleriaTurquoiseDkGoldDkGold": {
        "alias": "galleriaTurquoiseDkGoldDkGold",
        "name": "turquoise dark gold dark Gold",
        "subType": "galleria",
        "active": true
      },
      "medaDkGreyLtGrey_b": {
        "alias": "medaDkGreyLtGrey_b",
        "name": "dark grey light grey b",
        "subType": "meda",
        "active": true
      },
      "medaIndBluePeri_b": {
        "alias": "medaIndBluePeri_b",
        "name": "indigo blue peri b",
        "subType": "meda",
        "active": true
      },
      "medaOrangePrPink_b": {
        "alias": "medaOrangePrPink_b",
        "name": "orange prussian pink b",
        "subType": "meda",
        "active": true
      },
      "palestroDkGreyBordeaux": {
        "alias": "palestroDkGreyBordeaux",
        "name": "dark grey bordeaux",
        "subType": "palestro",
        "active": true
      },
      "palestroLtGreyDkChocolate": {
        "alias": "palestroLtGreyDkChocolate",
        "name": "light grey dark chocolate",
        "subType": "palestro",
        "active": true
      },
      "palestroPeriOrange": {
        "alias": "palestroPeriOrange",
        "name": "peri orange",
        "subType": "palestro",
        "active": true
      },
      "velaDkChocolateWhite": {
        "alias": "velaDkChocolateWhite",
        "name": "dark chocolate white",
        "subType": "vela",
        "active": true
      },
      "velaDkGoldWhite_b": {
        "alias": "velaDkGoldWhite_b",
        "name": "dark gold white b",
        "subType": "vela",
        "active": true
      },
      "velaDkGreyWhite_c": {
        "alias": "velaDkGreyWhite_c",
        "name": "dark grey white c",
        "subType": "vela",
        "active": true
      },
      "velascaBordeauxSand": {
        "alias": "velascaBordeauxSand",
        "name": "ordeaux sand",
        "subType": "velasca",
        "active": true
      },
      "velascaDkChocolateOrange": {
        "alias": "velascaDkChocolateOrange",
        "name": "dark chocolate orange",
        "subType": "velasca",
        "active": true
      },
      "velascaDkGreyLtGrey": {
        "alias": "velascaDkGreyLtGrey",
        "name": "dark grey light grey",
        "subType": "velasca",
        "active": true
      }
    }
  },
  "jacquardBlue": {
    "name": "jacquard",
    "list": {
      "accademiaBordeauxPwPink": {
        "alias": "accademiaBordeauxPwPink",
        "name": "bordeaux powder pink",
        "subType": "accademia",
        "active": true
      }, 
      "accademiaDkChocolateLtGrey": {
        "alias": "accademiaDkChocolateLtGrey",
        "name": "dark chocolate liht grey",
        "subType": "accademia",
        "active": true
      }, 
      "accademiaDkGreyLtGrey": {
        "alias": "accademiaDkGreyLtGrey",
        "name": "dark grey light grey",
        "subType": "accademia",
        "active": true
      }, 
      "accademiaOrangeWhite_b": {
        "alias": "accademiaOrangeWhite_b",
        "name": "orange white",
        "subType": "accademia",
        "active": true
      },
      "velaDkChocolate": {
        "alias": "velaDkChocolate",
        "name": "dark chocolate",
        "subType": "vela",
        "active": true
      }, 
      "velaDkGold": {
        "alias": "velaDkGold",
        "name": "dark gold",
        "subType": "vela",
        "active": true
      }, 
      "velaDkGrey": {
        "alias": "velaDkGrey",
        "name": "dark grey",
        "subType": "vela",
        "active": true
      }, 
      "velaWhite": {
        "alias": "velaWhite",
        "name": "white",
        "subType": "vela",
        "active": true
      }
    }
  },
  "timelessBlue": {
    "name": "timeless",
    "list": {
      "fontanaBordeaux": {
        "alias": "fontanaBordeaux",
        "name": "bordeaux",
        "subType": "fontana",
        "active": true
      },
      "fontanaDkGold": {
        "alias": "fontanaDkGold",
        "name": "dark gold",
        "subType": "fontana",
        "active": true
      },
      "fontanaDkGrey": {
        "alias": "fontanaDkGrey",
        "name": "dark grey",
        "subType": "fontana",
        "active": true
      },
      "fontanaIndBlue": {
        "alias": "fontanaIndBlue",
        "name": "indigo blue",
        "subType": "fontana",
        "active": true
      },
      "fontanaTurquoise": {
        "alias": "fontanaTurquoise",
        "name": "turquoise",
        "subType": "fontana",
        "active": true
      },
      "naviglioBordeaux": {
        "alias": "naviglioBordeaux",
        "name": "bordeaux",
        "subType": "naviglio",
        "active": true
      },
      "naviglioDkGold": {
        "alias": "naviglioDkGold",
        "name": "dark gold",
        "subType": "naviglio",
        "active": true
      },
      "naviglioDkGrey": {
        "alias": "naviglioDkGrey",
        "name": "dark grey",
        "subType": "naviglio",
        "active": true
      },
      "naviglioIndBlue": {
        "alias": "naviglioIndBlue",
        "name": "indigo blue",
        "subType": "naviglio",
        "active": true
      },
      "naviglioTurquoise": {
        "alias": "naviglioTurquoise",
        "name": "turquoise",
        "subType": "naviglio",
        "active": true
      },
      "piazzaBlue": {
        "alias": "piazzaBlue",
        "name": "blue",
        "subType": "piazza",
        "active": true
      },
      "piazzaBordeaux": {
        "alias": "piazzaBordeaux",
        "name": "bordeaux",
        "subType": "piazza",
        "active": true
      },
      "piazzaGold": {
        "alias": "piazzaGold",
        "name": "gold",
        "subType": "piazza",
        "active": true
      },
      "piazzaGrey": {
        "alias": "piazzaGrey",
        "name": "grey",
        "subType": "piazza",
        "active": true
      },
      "piazzaTurquoise": {
        "alias": "piazzaTurquoise",
        "name": "turquoise",
        "subType": "piazza",
        "active": true
      }
    }
  },
  "timelessMagenta": {
    "name": "timeless",
    "list": {
      "sforzaBlack": {
        "alias": "sforzaBlack",
        "name": "black",
        "subType": "sforza",
        "active": true
      },
      "sforzaBordeaux": {
        "alias": "sforzaBordeaux",
        "name": "bordeaux",
        "subType": "sforza",
        "active": true
      },
      "sforzaDkChocolate": {
        "alias": "sforzaDkChocolate",
        "name": "dark chocolate",
        "subType": "sforza",
        "active": true
      },
      "sforzaDkGold": {
        "alias": "sforzaDkGold",
        "name": "dark gold",
        "subType": "sforza",
        "active": true
      },
      "sforzaDkGrey": {
        "alias": "sforzaDkGrey",
        "name": "dark grey",
        "subType": "sforza",
        "active": true
      },
      "sforzaGrGreen": {
        "alias": "sforzaGrGreen",
        "name": "grass green",
        "subType": "sforza",
        "active": true
      },
      "sforzaIndBlue": {
        "alias": "sforzaIndBlue",
        "name": "indigo blue",
        "subType": "sforza",
        "active": true
      },
      "sforzaIvory": {
        "alias": "sforzaIvory",
        "name": "ivory",
        "subType": "sforza",
        "active": true
      },
      "sforzaLtGold": {
        "alias": "sforzaLtGold",
        "name": "light gold",
        "subType": "sforza",
        "active": true
      },
      "sforzaLtGrey": {
        "alias": "sforzaLtGrey",
        "name": "grey",
        "subType": "sforza",
        "active": true
      },
      "sforzaNavy": {
        "alias": "sforzaNavy",
        "name": "navy",
        "subType": "sforza",
        "active": true
      },
      "sforzaOrange": {
        "alias": "sforzaOrange",
        "name": "orange",
        "subType": "sforza",
        "active": true
      },
      "sforzaPeri": {
        "alias": "sforzaPeri",
        "name": "peri",
        "subType": "sforza",
        "active": true
      },
      "sforzaPwPink": {
        "alias": "sforzaPwPink",
        "name": "powder pink",
        "subType": "sforza",
        "active": true
      },
      "sforzaSand": {
        "alias": "sforzaSand",
        "name": "sand",
        "subType": "sforza",
        "active": true
      },
      "sforzaTurquoise": {
        "alias": "sforzaTurquoise",
        "name": "turquoise",
        "subType": "sforza",
        "active": true
      },
      "sforzaViolet": {
        "alias": "sforzaViolet",
        "name": "violet",
        "subType": "sforza",
        "active": true
      },
      "sforzaWhite": {
        "alias": "sforzaWhite",
        "name": "white",
        "subType": "sforza",
        "active": true
      }
    }
  }
}

export default atomsObj